var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IdfButton',{attrs:{"kind":"secondary","tag":"router-link","iconLeft":"plus","route":_vm.route,"data-test":"discount-duplicate-button"}},[_vm._v(_vm._s(_vm.$t('ctx.discount.detail.duplicate')))])
}
var staticRenderFns = []

export { render, staticRenderFns }